import React from "react";
import svgUrl from "/opt/actions-runner/_work/v3-swap/v3-swap/src/assets/wallets/browser-wallet-light.svg?url";
const SvgBrowserWalletLight = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("rect", {
  x: 1,
  y: 1,
  width: 40,
  height: 40,
  fill: "#FB118E",
  fillOpacity: 0.12
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.454 12.6305C15.6973 13.4936 12.8284 16.6822 12.4439 20.5998H16.6425C16.8586 17.7339 17.8329 14.9847 19.454 12.6305ZM23.546 12.6305C25.1671 14.9847 26.1413 17.7339 26.3574 20.5998H30.5561C30.1715 16.6822 27.3027 13.4936 23.546 12.6305ZM24.5517 20.5998C24.3127 17.7852 23.2508 15.103 21.5 12.8882C19.7491 15.103 18.6872 17.7852 18.4483 20.5998H24.5517ZM18.4483 22.3998H24.5516C24.3126 25.2143 23.2507 27.8963 21.5 30.111C19.7492 27.8963 18.6873 25.2143 18.4483 22.3998ZM16.6426 22.3998H12.4439C12.8286 26.3172 15.6974 29.5056 19.454 30.3687C17.833 28.0146 16.8587 25.2656 16.6426 22.3998ZM23.546 30.3687C25.167 28.0146 26.1412 25.2656 26.3574 22.3998H30.556C30.1713 26.3172 27.3026 29.5056 23.546 30.3687ZM21.5 32.3996C15.4801 32.3996 10.6 27.5195 10.6 21.4996C10.6 15.4797 15.4801 10.5996 21.5 10.5996C27.5199 10.5996 32.4 15.4797 32.4 21.4996V21.4998C32.3999 27.5196 27.5198 32.3996 21.5 32.3996Z",
  fill: "#FB118E"
}), /* @__PURE__ */ React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 40.5,
  height: 40.5,
  stroke: "#5D6785",
  strokeOpacity: 0.24,
  strokeWidth: 0.5
}));
export {SvgBrowserWalletLight as ReactComponent};
export default svgUrl;
